export default __webpack_public_path__ + "static/media/background.7390d9ea.png";